import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import Feature from 'ol/Feature';
import VectorSource from 'ol/source/Vector';
import { Vector as VectorLayer } from 'ol/layer';
import StyleFunction from 'ol/style';
import { MapComponent } from '../map.component';

@Component({
    selector: 'app-events-layer',
    template: ''
})
export class EventsLayerComponent implements OnInit, OnChanges, OnDestroy {
    @Input() id: string;
    @Input() visible: boolean;
    @Input() features: Feature[];
    @Input() styleFunction: StyleFunction;

    private lastZoom: number;

    vectorLayer: VectorLayer;

    constructor(
        private _map: MapComponent
    ) { }

    ngOnInit(): void {
        this.vectorLayer = this.initializeVectorLayer();
        this._map.instance.addLayer(this.vectorLayer);
        this.lastZoom = this._map.instance.getView().getZoom();
        this._map.instance.on('moveend', () => {
            const currentZoom: number = this._map.instance.getView().getZoom();
            if (this.lastZoom === currentZoom) {
                return;
            }
            let featuresToRender: Feature[] = currentZoom >= 16 ? this.features : [];
            this.vectorLayer.getSource().clear();
            this.vectorLayer.getSource().addFeatures(featuresToRender);
            this.lastZoom = currentZoom;
        });
        if (this.id) {
            this.vectorLayer.set('id', this.id);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.vectorLayer) {
            return;
        }
        if ('features' in changes) {
            const currentZoom: number = this._map.instance.getView().getZoom();
            let featuresToRender: Feature[] = currentZoom >= 16 ? this.features : [];
            this.vectorLayer.getSource().clear();
            this.vectorLayer.getSource().addFeatures(featuresToRender);
        }
        if ('visible' in changes) {
            this.vectorLayer.setVisible(this.visible);
        }
    }

    ngOnDestroy(): void {
        this.vectorLayer.getSource().clear();
        this._map.instance.removeLayer(this.vectorLayer);
    }

    initializeVectorLayer(): VectorLayer {
        return new VectorLayer({
            visible: this.visible,
            source: new VectorSource({
                features: this.features ? this.features : [],
            }),
            style: this.styleFunction ? this.styleFunction : undefined
        });
    }
}



// WEBPACK FOOTER //
// ./libs/map/components/layers/events-layer.component.ts